import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getRoleDetails } from '../../../actions/roleActions';

import GenericButton from '../../common/GenericButton';
import ListItems from './ListItems';

class RoleListBox extends Component {
  static propTypes = {
    roles: PropTypes.instanceOf(Array),
    activeRoles: PropTypes.instanceOf(Array),
    updateSelectedItems: PropTypes.func,
    clearItems: PropTypes.bool,
    activePermissions: PropTypes.instanceOf(Array),
    activationKey: PropTypes.bool,
  };

  static defaultProps = {
    roles: [],
    activeRoles: [],
    clearItems: false,
    activationKey: false,
  };

  state = {
    items: [],
    itemsLeft: [],
    selectedItemsLeft: [],
    itemsRight: [],
    selectedItemsRight: [],
    rightSelectionCount: 0,
    originalBaseLists: [],
    disableButtons: false,
    roles: [],
  };

  UNSAFE_componentWillMount() {
    this.setState({ roles: this.props.roles }, () => {
      this.updateInitialState();
    });
  }

  UNSAFE_componentWillReceiveProps({ clearItems, activeRoles, roles }) {
    if (clearItems !== this.props.clearItems) {
      this.removeAll();
    }
    if (!_.isEqual(roles, this.state.roles)) {
      this.setState({ roles }, () => {
        this.updateInitialState();
      });
    }
    if (!_.isEqual(activeRoles, this.state.itemsRight)) {
      this.setState(
        {
          items: [],
          itemsLeft: [],
          selectedItemsLeft: [],
          itemsRight: [],
          selectedItemsRight: [],
          rightSelectionCount: 0,
          originalBaseLists: [],
        },
        () => {
          this.updateInitialState();
        }
      );
    }
  }

  updateInitialState = () => {
    const roles = this.renderData();
    const selectedItemsLeft = [];
    roles.map((role, i) => {
      if (role.isActive) {
        selectedItemsLeft.push(i);
      }
      return null;
    });
    this.setState(
      {
        items: roles,
        itemsLeft: roles,
        selectedItemsLeft,
        originalBaseLists: roles,
      },
      () => {
        if (selectedItemsLeft.length > 0) {
          this.addSelected();
        }
      }
    );
  };

  handleSearch = searchResult => this.setState({ itemsLeft: searchResult });

  handleLeftPanelClick = (itemId, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsLeft;
      }
      selectedItems.push(parseInt(itemId, 10));
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsLeft;
      let lastItem = this.state.selectedItemsLeft.pop();
      let currentItemId = itemId;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsLeft.map(item => {
        if (
          item.itemId >= lastItem &&
          item.itemId <= parseInt(currentItemId, 10)
        ) {
          selectedItems.push(item.itemId);
        }
        return item;
      });
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    }
  };

  addSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsLeft.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsRight.map(item => {
      selections.push(item);
      return item;
    });
    this.setState(
      {
        itemsLeft: itemsRemaining,
        itemsRight: selections,
        rightSelectionCount: selections.length,
        selectedItemsRight: [],
        selectedItemsLeft: [],
      },
      () => {
        this.props.updateSelectedItems(this.state.itemsRight);
      }
    );
  };

  removeSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsRight.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsLeft.map(item => {
      selections.push(item);
      return item;
    });
    this.setState(
      {
        itemsLeft: selections,
        itemsRight: itemsRemaining,
        rightSelectionCount: itemsRemaining.length,
        selectedItemsRight: [],
        selectedItemsLeft: [],
      },
      () => {
        this.props.updateSelectedItems(this.state.itemsRight);
      }
    );
  };

  handleMoveAllLeft = () => {
    const { itemsLeft, itemsRight } = this.state;
    const allItemsToLeft = itemsRight;
    _.map(itemsLeft, item => {
      allItemsToLeft.push(item);
    });
    this.setState(
      {
        itemsLeft: allItemsToLeft,
        itemsRight: [],
        rightSelectionCount: 0,
        selectedItemsRight: [],
        selectedItemsLeft: [],
      },
      () => {
        this.props.updateSelectedItems([]);
      }
    );
  };

  handleMoveAllRight = () => {
    const { itemsLeft, itemsRight } = this.state;
    const allItemsToRight = itemsLeft;
    _.map(itemsRight, item => {
      allItemsToRight.push(item);
    });
    this.setState(
      {
        itemsRight: allItemsToRight,
        itemsLeft: [],
        selectedItemsLeft: [],
        selectedItemsRight: [],
      },
      () => {
        this.props.updateSelectedItems(this.state.itemsRight);
      }
    );
  };

  removeAll = () => {
    const leftPanelItems = [];
    leftPanelItems.push(...this.state.itemsLeft, ...this.state.itemsRight);
    this.setState(
      {
        itemsRight: [],
        itemsLeft: leftPanelItems,
        rightSelectionCount: 0,
        selectedItemsRight: [],
        selectedItemsLeft: [],
      },
      () => {
        this.props.updateSelectedItems(this.state.itemsRight);
      }
    );
  };

  handleRightPanelClick = (itemId, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsRight;
      }
      selectedItems.push(parseInt(itemId, 10));
      this.setState({
        selectedItemsRight: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsRight;
      let lastItem = this.state.selectedItemsRight.pop();
      let currentItemId = itemId;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsRight.map(item => {
        if (
          item.itemId >= lastItem &&
          item.itemId <= parseInt(currentItemId, 10)
        ) {
          selectedItems.push(item.itemId);
        }
        return item;
      });
      this.setState({
        selectedItemsRight: selectedItems,
      });
    }
  };

  renderData = () => {
    const roles = this.state.roles;
    const activeRoles = this.props.activeRoles;
    const items = roles.map((role, index) => {
      const activeRole = _.filter(activeRoles, item => item.id === role.id);
      const selected = activeRole.length > 0;
      const items = {
        ...role,
        itemId: index,
        text: role.name,
        selected: false,
        isActive: selected,
        children: [],
      };
      return items;
    });
    return items;
  };

  renderSearchItems = () => {
    const { items, itemsRight } = this.state;
    const filteredItems = [];
    _.map(items, item => {
      const hasItem = _.filter(itemsRight, k => k.id === item.id);
      if (_.isEmpty(hasItem)) {
        filteredItems.push(item);
      }
    });
    return filteredItems;
  };

  filterFromUserPermission = (modules, userModules) => {
    const filteredModules = [];
    _.map(modules, module => {
      const userModule = _.find(
        userModules,
        item => item.moduleId === module.moduleId
      );
      if (userModule) {
        const permissions = [];
        module.permissions.map(permission => {
          const hasPermission = userModule.permissions.find(
            item => item.id === permission.id
          );
          if (hasPermission) {
            permissions.push(permission);
          }
          return false;
        });
        const data = {
          ...module,
          permissions,
        };

        filteredModules.push(data);
      }
    });
    return filteredModules;
  };

  handleExpendTree = (e, id, hasChild, position) => {
    e.stopPropagation();
    let positionItem = _.cloneDeep(this.state.itemsLeft);
    if (position === 'right') {
      positionItem = _.cloneDeep(this.state.itemsRight);
    }
    // let updateChildrenInItem = itemsLeft;
    if (hasChild) {
      const items = _.map(positionItem, item => {
        let children = item.children;
        if (item.id === id) {
          children = [];
        }
        const data = {
          ...item,
          children,
        };
        return data;
      });
      if (position === 'right') {
        this.setState({ itemsRight: items, disableButtons: false });
      } else {
        this.setState({ itemsLeft: items, disableButtons: false });
      }
    } else {
      this.setState({ disableButtons: true }, () => {
        getRoleDetails(id).then(response => {
          const items = _.map(positionItem, item => {
            let children = item.children;
            if (response && item.id === id) {
              if (
                position === 'right' &&
                this.props.userPermission &&
                this.props.userPermission.length > 0
              ) {
                children = this.filterFromUserPermission(
                  response.modules,
                  this.props.userPermission
                );
              } else {
                children = response.modules;
              }
            }
            const data = {
              ...item,
              children,
            };
            return data;
          });
          if (position === 'right') {
            this.setState({ itemsRight: items, disableButtons: false });
          } else {
            this.setState({ itemsLeft: items, disableButtons: false });
          }
        });
      });
    }
  };

  render() {
    const {
      itemsLeft,
      selectedItemsLeft,
      selectedItemsRight,
      itemsRight,
      disableButtons,
    } = this.state;
    return (
      <div className="multi-select-search-component">
        <div className="add-user-form--row">
          <div className="add-user-form--col">
            <div className="base-left-label">Available Role(s)</div>
            <ListItems
              items={itemsLeft}
              selectedItems={selectedItemsLeft}
              handleSelection={this.handleLeftPanelClick}
              handleExpendTree={this.handleExpendTree}
              position="left"
              activationKey={this.props.activationKey}
            />
          </div>
          <div className="add-user-form--col-center add-user-form--col">
            <div className="stacked button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-add btn-priaryDisable"
                onBtnClick={this.addSelected}
                btnDisabled={selectedItemsLeft.length < 1 || disableButtons}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-add-all btn-priaryDisable"
                onBtnClick={this.handleMoveAllRight}
                btnDisabled={itemsLeft.length < 1 || disableButtons}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-remove btn-cncl"
                onBtnClick={this.removeSelected}
                btnDisabled={selectedItemsRight.length < 1 || disableButtons}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-remove-all btn-priaryDisable"
                onBtnClick={this.handleMoveAllLeft}
                btnDisabled={itemsRight.length < 1 || disableButtons}
              />
            </div>
          </div>
          <div className="add-user-form--col">
            <div className="base-left-label">Selected Role(s)</div>
            <ListItems
              items={itemsRight}
              selectedItems={selectedItemsRight}
              handleSelection={this.handleRightPanelClick}
              handleExpendTree={this.handleExpendTree}
              position="right"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default RoleListBox;
